export default __webpack_public_path__ + "static/media/0xf7d9e281c5cb4c6796284c5b663b3593d2037af2.7b5cfdd1.png";